import { PublicClientApplication } from '@azure/msal-browser';

// const ua = window.navigator.userAgent;
// const msie = ua.indexOf('MSIE ');
// const msie11 = ua.indexOf('Trident/');
// const msedge = ua.indexOf('Edge/');
// const firefox = ua.indexOf('Firefox');
// const isIE = msie > 0 || msie11 > 0;
// const isEdge = msedge > 0;
// const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

export const msalConfig = {
  auth: {
    clientId: 'd3afb0ad-a8cb-452c-a627-11c707598408',
    authority: 'https://login.smarfac.com/da4d98ba-ece3-4f6a-88d7-b2fc4eaa1d64/B2C_1_SignIn',
    knownAuthorities: ['login.smarfac.com'],
    redirectUri: window.origin + '/signin-oidc',
    postLogoutRedirectUri: window.origin + '/login',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const MSAL_SCOPES = ['https://smarfac.onmicrosoft.com/api/access_as_user'];

export const msalInstance = new PublicClientApplication(msalConfig);
